export default "__VITE_ASSET__D5jfVIj5__"